import React from 'react';
import { injectIntl } from 'react-intl';
import Tooltip from '@material-ui/core/Tooltip';

/**
 * Tooltip informativo cuando un ítem tiene costo fijo
 * @param {Object} intl - Objeto de internacionalización de react-intl
 * @param {Boolean} costoFijo - Indica si el ítem tiene costo fijo
 * @param {String} descripcion - Descripción/nombre del ítem (opcional)
 */
const CostoFijoTooltip = ({ intl, costoFijo, descripcion }) => {
	if (!costoFijo) {
		return null;
	}

	return (
		<Tooltip
			title={
				<span style={{ fontSize: '0.9rem', lineHeight: 1.4, display: 'block' }}>
					{intl.formatMessage(
						{
							id: 'Presupuesto.Precio.monto_fijo_activado',
							defaultMessage:
								'{nombre} tiene monto fijo activado y no puede editarse manualmente.',
						},
						{ nombre: descripcion || intl.formatMessage({ id: 'Presupuesto.Item', defaultMessage: 'El ítem' }) }
					)}
				</span>
			}
			placement="top"
		>
			<span className="ml-1 text-info" style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
				<i className="fa fa-info-circle" />
			</span>
		</Tooltip>
	);
};

export default injectIntl(CostoFijoTooltip);

